import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class SiteAltitudeLine {
    _firstDot: marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot: marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    public spt: SVGSprite;

    /**
     * コンストラクタ
     * */
    constructor(targetNode: Element, id: string) {
      // ラインの作成
      const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      viewObj.setAttribute('stroke', '#66CCFF');
      viewObj.setAttribute('stroke-width', '1');
      viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(10, 10)));
      viewObj.setAttribute('id', `altitude_line_${id}`);
      this.spt = new SVGSprite(viewObj);
      targetNode.appendChild(viewObj);
      this.show();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (!this.firstDot || !this.secondDot) return;
      this.viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.firstDot.x, this.firstDot.y), new marietta.core.Point(this.secondDot.x, this.secondDot.y)));
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }
}
